"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Card.css");
var Button_1 = require("../button/Button");
var Link_1 = require("../link/Link");
var CardType;
(function (CardType) {
    CardType["actionable"] = "actionable";
})(CardType = exports.CardType || (exports.CardType = {}));
var CardComp = function (_a) {
    var type = _a.type, route = _a.route, props = __rest(_a, ["type", "route"]);
    //LinkProps type guard
    function isLinkProps(props, route) {
        return !!route;
    }
    return isLinkProps(props, route) ? (React.createElement(Link_1.LinkFR, __assign({}, props, { className: classnames_1.default('Card Button', {
            'Button-disabled': props.disabled,
            'Card-actionable': type === CardType.actionable,
        }), to: route }))) : (React.createElement(Button_1.ButtonFR, __assign({}, props, { className: classnames_1.default('Card', props.className, {
            'Card-actionable': type === CardType.actionable,
        }) })));
};
exports.Card = React.memo(CardComp);
